import { eventBus } from '@eventBus'
import cSocket from './cSocket'
export default {
    data() {
        return {
            tab_cSocket: null,
        }
    },
    methods: {
        tab_initSocket() {
            this.tab_cSocket = new cSocket({
                wss: 'wss://new-8002.fleetsoft.pro',
                token: this.user.token,
                name: '8002',
                onmessage: this.tab_onmessage,
                // console: false
            })
            eventBus.$on('socketEmit_tab', this.tab_cSocket.emit.bind(this.tab_cSocket));
            
        },
        tab_onmessage(action, data) {
            switch (action) {
                case 'updateTable':
                    eventBus.$emit('updateTable', data);
                    break;
                case 'ready_report':
                    eventBus.$emit('readyReport', data);
                    break;
                case 'error_report_processing':
                    eventBus.$emit('errorReport', data);
                    break;
                case 'create_call':
                    eventBus.$emit('createCall', data);
                    break;
                case 'update_call':
                    data.result_action == "action_end_call" ?  eventBus.$emit('endCall', data) : ''
                    break;
                default:
                    break;
            }
        }
    }
}